module.exports = __webpack_public_path__ + "static/img/teachers7.2dbeab54.png";